class FormsValidator {
  errors = {};
  submitBtn;
  submitDiv;

  constructor(props) {
    const { submitBtnId, submitDivId } = props;
    this.submitBtn = document.getElementById(submitBtnId);
    this.submitDiv = document.getElementById(submitDivId);
    this.controlSubmit();
  }

  registerInput(props) {
    const { mode, inputId, errorId, modifierBtnId, progressStepsIds } = props;
    this.errors = { ...this.errors, [inputId]: "Can't be blank" };
    const inputEl = document.getElementById(inputId);
    const errorEl = document.getElementById(errorId);
    if (!inputEl || !errorEl) return;
    errorEl.textContent = '';

    switch (mode) {
      case 'email':
        inputEl.focus();
        inputEl.addEventListener('input', (e) => {
          if (e.target.value === '') {
            const errorTxt = "Can't be blanc";
            errorEl.textContent = errorTxt;
            this.errors = { ...this.errors, [inputId]: errorTxt };
          } else if (
            !e.target.value
              .toLowerCase()
              .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              )
          ) {
            const errorTxt = 'Must be valid email format';
            errorEl.textContent = errorTxt;
            this.errors = { ...this.errors, [inputId]: errorTxt };
          } else {
            delete this.errors[inputId];
            errorEl.textContent = '';
          }
          this.validateSubmit();
        });
        break;
      case 'password':
        inputEl.addEventListener('input', (e) => {
          if (e.target.value === '') {
            const errorTxt = "Can't be blanc";
            errorEl.textContent = errorTxt;
            this.errors = { ...this.errors, [inputId]: errorTxt };
          } else if (e.currentTarget.value.length < 5) {
            const errorTxt = 'Must be at least 5 characters long';
            errorEl.textContent = errorTxt;
            this.errors = { ...this.errors, [inputId]: errorTxt };
          } else {
            delete this.errors[inputId];
            errorEl.textContent = '';
          }
          this.validateSubmit();
        });

        if (modifierBtnId) {
          const switchBtnEl = document.getElementById(modifierBtnId);
          let isPasswordVisible = false;
          switchBtnEl.addEventListener('click', (e) => {
            e.preventDefault();
            isPasswordVisible = !isPasswordVisible;
            const hideImg = document.getElementById('modHide');
            const showImg = document.getElementById('modShow');

            if (isPasswordVisible) {
              showImg.classList.remove('forms-hidden');
              hideImg.classList.add('forms-hidden');
              inputEl.type = 'text';
            } else {
              hideImg.classList.remove('forms-hidden');
              showImg.classList.add('forms-hidden');
              inputEl.type = 'password';
            }
          });
        }
        break;
      case 'newPassword':
        inputEl.addEventListener('input', (e) => {
          if (e.target.value === '') {
            const errorTxt = "Can't be blanc";
            errorEl.textContent = errorTxt;
            this.errors = { ...this.errors, [inputId]: errorTxt };
            this.setSteps(progressStepsIds, '0');
          } else if (e.currentTarget.value.length < 5) {
            const errorTxt =
              'Minimum 5 characters. The strongest password you choose, the safer your account data. A strong password should contain a minimum of 8 characters.';
            errorEl.textContent = errorTxt;
            this.errors = { ...this.errors, [inputId]: errorTxt };
            this.setSteps(progressStepsIds, '1');
          } else if (e.currentTarget.value.length < 8) {
            const errorTxt =
              'The strongest password you choose, the safer your account data. A strong password should contain a minimum of 8 characters.';
            errorEl.textContent = errorTxt;
            delete this.errors[inputId];
            this.setSteps(progressStepsIds, '2');
          } else {
            delete this.errors[inputId];
            errorEl.textContent = 'Your password is strong!';
            this.setSteps(progressStepsIds, '3');
          }
          this.validateSubmit();
        });

        if (modifierBtnId) {
          const switchBtnEl = document.getElementById(modifierBtnId);
          let isPasswordVisible = false;
          switchBtnEl.addEventListener('click', (e) => {
            e.preventDefault();
            isPasswordVisible = !isPasswordVisible;
            const hideImg = document.getElementById('modHide');
            const showImg = document.getElementById('modShow');

            if (isPasswordVisible) {
              showImg.classList.remove('forms-hidden');
              hideImg.classList.add('forms-hidden');
              inputEl.type = 'text';
            } else {
              hideImg.classList.remove('forms-hidden');
              showImg.classList.add('forms-hidden');
              inputEl.type = 'password';
            }
          });
        }
        break;
      default:
        break;
    }

    this.validateSubmit();
  }

  setSteps(progressStepsIds, level) {
    if (!progressStepsIds.length) return;
    const progressSteps = [];

    progressStepsIds.forEach((id) => {
      const el = document.getElementById(id);
      progressSteps.push(el);
    });

    progressSteps.forEach((step) => {
      this.removeStepColors(step);
    });
    switch (level) {
      case '0':
        break;
      case '1':
        progressSteps.forEach((step, index) => {
          switch (index) {
            case 0:
              step.classList.add('forms-progress-step--red');
              break;
            default:
              break;
          }
        });
        break;
      case '2':
        progressSteps.forEach((step, index) => {
          switch (index) {
            case 0:
              step.classList.add('forms-progress-step--yellow');
              break;
            case 1:
              step.classList.add('forms-progress-step--yellow');
              break;
            default:
              break;
          }
        });
        break;
      case '3':
        progressSteps.forEach((step, index) => {
          switch (index) {
            case 0:
              step.classList.add('forms-progress-step--green');
              break;
            case 1:
              step.classList.add('forms-progress-step--green');
              break;
            case 2:
              step.classList.add('forms-progress-step--green');
              break;
            default:
              break;
          }
        });
        break;
      default:
        break;
    }
  }

  removeStepColors(step) {
    step.classList.remove('forms-progress-step--red');
    step.classList.remove('forms-progress-step--yellow');
    step.classList.remove('forms-progress-step--green');
  }

  validateSubmit() {
    if (Object.keys(this.errors).length) {
      this.submitBtn.disabled = true;
    } else {
      this.submitBtn.disabled = false;
    }
  }

  controlSubmit() {
    if (!this.submitDiv) return;
    this.submitDiv.addEventListener('click', (e) => {
      if (Object.keys(this.errors).length) {
        Object.keys(this.errors).forEach((key) => {
          const el = document.getElementById(key);
          if (!el) return;
          el.classList.add('forms-invalid');
          setTimeout(() => {
            el.classList.remove('forms-invalid');
          }, 250);
        });
      }
    });
  }

  mirrorValue(props) {
    const { originalValueId, targetValueId } = props;
    const originalEl = document.getElementById(originalValueId);
    const targetEl = document.getElementById(targetValueId);

    if (!originalEl || !targetEl) return;

    originalEl.addEventListener('input', (e) => {
      targetEl.value = e.target.value;
    });
  }
}
